let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("436Ac")).then(() => parcelRequire('dp9iK'));